import { render } from "./UploadInspectionContent.vue?vue&type=template&id=d9c87c94&scoped=true"
import script from "./UploadInspectionContent.vue?vue&type=script&lang=js"
export * from "./UploadInspectionContent.vue?vue&type=script&lang=js"

import "./UploadInspectionContent.vue?vue&type=style&index=0&id=d9c87c94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9c87c94"]])

export default __exports__